import baseEnv from "./env.base";
const BACKEND_API_URL = process.env.BACKEND_API_URL;
const BASE_URL = BACKEND_API_URL || `https://api.catalogyapp.com`;

const productionEnv = {
  ...baseEnv,
  production: true,
  APIURL: BASE_URL,
  HOME_URL: "catalogyapp.com",
  SENTRY_ENV: "production",
};

export default productionEnv;
